// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__nXYuh","arrow":"styles_arrow__QsHtt","sliderContainer":"styles_sliderContainer__ZIAj4","sliderItem":"styles_sliderItem__frXZT"};